<div class="overlay" *ngIf="ShowConfirmationQuestion || ShowOrderCancelation || ShowOrderCopy || ShowEditContainer;"></div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowOrderCopy">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowOrderCopy = false; CurrentOrder = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'CopyOfferRequestTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'CopyOfferRequestDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowOrderCopy = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowOrderCopy = false;CopyOrder(CurrentOrder);">{{ 'AcceptAndContinueCopy' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowOrderCancelation">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowOrderCancelation = false; CurrentOrder = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'CancelQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'CancelQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowOrderCancelation = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowOrderCancelation = false;CancelOrder(CurrentOrder);">{{ 'YesCancel' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowConfirmationQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowConfirmationQuestion = false; CurrentOrder = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ConfirmOrder' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'ConfirmOrderDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="ConfirmOrder(CurrentOrder); ShowConfirmationQuestion = false; CurrentOrder = null;">{{ 'ConfirmOrder' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowConfirmationQuestion = false;">{{ 'YesCancel' | translate }}</button>
  </div>
</div>

<div class="EditContainer animated fadeInDown" *ngIf="this.ShowEditContainer == true;">
    <div class="EditContainerCloseButton" (click)="this.ShowEditContainer = false;">
        <i class="material-icons">close</i>
    </div>
    <div class="EditContainerHeadder">
      <p class="EditContainerHeadderTitle">
        <span class="EditContainerReferenceNumber">{{CurrentOrder.ReferenceNumber}}</span>
        <span class="EditContainerDebatorPO" *ngIf="CurrentOrder?.DebatorPO?.length > 0;">{{CurrentOrder.DebatorPO}}</span>
      </p>
    </div>
    <div class="EditContainerBody">

      <div class="EditContainerBodyStatus unSelectable">
        <span class="EditContainerBodyStatusTitle">Status: </span>
        <span class="OrdersRowColInfoStatusSpan" [ngClass]="{'NewOrderStatus': CurrentOrder.OfferRequestStatus.ID == -1, 'ProcessingOrderStatus': CurrentOrder.OfferRequestStatus.ID == 1,'PartiallyConfirmedOrderStatus': CurrentOrder.OfferRequestStatus.ID == 9,'ConfirmedOrderStatus': CurrentOrder.OfferRequestStatus.ID == 10, 'CanceledOrderStatus': CurrentOrder.OfferRequestStatus.ID == 11}">{{CurrentOrder.OfferRequestStatus.Name}}</span>
      </div>

      <div class="EditContainerBodySection">
        <div class="EditContainerBodySectionTitle unSelectable">
          <i class="material-icons">info</i>
          <span>{{'GeneralInfomration' | translate}}</span>
          <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderGeneralInformation = true;" *ngIf="this.ShowOrderGeneralInformation == false;">keyboard_arrow_right</i>
          <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderGeneralInformation = false;" *ngIf="this.ShowOrderGeneralInformation == true;">keyboard_arrow_down</i>
        </div>
  
        <div class="DottedSectionButton" *ngIf="this.ShowOrderGeneralInformation == false;" (click)="this.ShowOrderGeneralInformation = true;">
          <span>...</span>
        </div>
  
        <div *ngIf="this.ShowOrderGeneralInformation == true;">
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'RequestNumber' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'RequestNumber' | translate}}" [(ngModel)]="this.CurrentOrder.ReferenceNumber" matInput>
            </div>
          </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'DebatorPO' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input style="letter-spacing: 2px;font-weight: 500;color: #f60;" type="text" class="TextBoxContainer" placeholder="{{'DebatorPO' | translate}}" [(ngModel)]="this.CurrentOrder.DebatorPO" matInput>
              </div>
            </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'Uploader' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'UserUploader' | translate}}" [(ngModel)]="this.CurrentOrder.UserUploader.UIName" matInput>
              </div>
            </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'Manager' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'UserUploader' | translate}}" [(ngModel)]="this.CurrentOrder.UserManager.UIName" matInput>
              </div>
            </div>
  
            <div class="CartSummary unSelectable CartSummarySmaller">
              <div class="CartSummaryTitle">
                <p>{{'OrderContactAgents' | translate}}</p>
              </div>
            
              <div class="PartnerAgentRow" *ngFor="let agent of this.CurrentOrder.Cart.Partner?.PartnerAgents" [ngClass]="{ 'UnSelectedAgent': agent.IsSelected != true}" (click)="agent.IsSelected = !agent.IsSelected;">
                <p>{{agent.Email}}</p>
                <i class="material-icons" *ngIf="agent.IsSelected == true;" style="color: #32aa3a;">check</i>
                <i class="material-icons" *ngIf="agent.IsSelected != true;" style="color: #fd4f57;">close</i>
              </div>
            </div>
        </div>
      </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">insert_drive_file</i>
            <span>{{'BillingInformation' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderBillingInformation = true;" *ngIf="this.ShowOrderBillingInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderBillingInformation = false;" *ngIf="this.ShowOrderBillingInformation == true;">keyboard_arrow_down</i>
          </div>
  
          <div class="DottedSectionButton" *ngIf="this.ShowOrderBillingInformation == false;" (click)="this.ShowOrderBillingInformation = true;">
            <span>...</span>
          </div>
  
         <div *ngIf="this.ShowOrderBillingInformation == true;">
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'Name' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Name' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.Name" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'VAT' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'VAT' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.VAT" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'COCRegNumber' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'COCRegNumber' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.COCRegNumber" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'Country' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Country' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.Country.Name" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'StateProvince' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'StateProvince' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.StateProvince" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'City' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'City' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.City" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'AddressLine' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'AddressLine' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.AddressLine" matInput>
            </div>
          </div>
         </div>
        </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">airplanemode_on</i>
            <span>{{'ShippingAddresses' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderShippingInformation = true;" *ngIf="this.ShowOrderShippingInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderShippingInformation = false;" *ngIf="this.ShowOrderShippingInformation == true;">keyboard_arrow_down</i>
          </div>
  
          <div class="DottedSectionButton" *ngIf="this.ShowOrderShippingInformation == false;" (click)="this.ShowOrderShippingInformation = true;">
            <span>...</span>
          </div>
  
           <div *ngIf="this.ShowOrderShippingInformation == true;">
            <mat-form-field appearance="outline"class="EditContainerBodyDropDown" *ngIf="this.CurrentOrder.Cart.Partner.ShippingAddresses?.length > 0">
              <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
              <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentOrder.ShippingAddress" style="height: 30px;padding-top: 7px;">
                <mat-option *ngFor="let a of this.CurrentOrder.Cart.Partner.ShippingAddresses" [value]="a">
                  {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
          <mat-form-field appearance="outline" class="EditContainerBodyDropDown">
            <mat-label>{{ 'Country' | translate }}</mat-label>
            <mat-select disabled="true" name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentOrder.ShippingAddress.Country" style="height: 30px;padding-top: 7px;">
              <mat-option *ngFor="let c of this.parent.masterData.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'StateProvince' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'StateProvince' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.State" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'Partners.PartnerWindow.City' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.City' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.City" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'Partners.PartnerWindow.AddressLine' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.AddressLine' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.AddressLine" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'ZipCode' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" style="letter-spacing: 2px;font-weight: 500;" type="text" class="TextBoxContainer" placeholder="{{'ZipCode' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.ZipCode" matInput>
          </div>
          </div>
           </div>
        </div>

        <div class="EditContainerBodySection" style="overflow: unset;border: none;">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">shopping_cart</i>
            <span>{{'Products' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderProductsInformation = true;" *ngIf="this.ShowOrderProductsInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderProductsInformation = false;" *ngIf="this.ShowOrderProductsInformation == true;">keyboard_arrow_down</i>
          </div>

          <div class="DottedSectionButton" *ngIf="this.ShowOrderProductsInformation == false;" (click)="this.ShowOrderProductsInformation = true;">
            <span>...</span>
          </div>

          <div *ngIf="this.ShowOrderProductsInformation == true;">
            <div class="GridContainer">
              <div class="GridRow">
                <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px);">
                  #
                </div>
            
                <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(5% - 2px);">
                  {{'Brand' | translate}}
                </div>
            
              <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(25% - 2px);" matTooltip="{{ 'ProductNamePartNumberDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
                 {{'ProductNamePartNumber' | translate}}
              </div>

              <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(30% - 2px);" matTooltip="{{ 'OfferingPartner' | translate}}" matTooltipClass='neutral-tool-tip'>
                {{'OfferingPartner' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px);">
                {{'Quantity' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'Price' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'Total' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'ETA' | translate}}
              </div>
              </div>
            
              <div class="GridRow" *ngFor="let item of this.CurrentOrder.Cart?.Items; let i = index;">
                <div class="GridCol" style="width: Calc(5% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{i + 1}}
                </div>
            
                <div class="GridCol leftText" style="width: Calc(5% - 2px);  cursor: pointer;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}" (click)="this.parent.InitializeSearchProduct(item);">
                  <p *ngIf="item?.CartItemStatus?.ID >= 0;">{{item?.Product?.Brand?.Name}}</p>
                  <p *ngIf="item?.CartItemStatus?.ID == -1;"></p>
                  <p *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand == null;">
                  </p>
                  <p *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand != null;">
                    {{item?.UserSelectedBrand?.Name}}
                  </p>
            
                  <div *ngIf="item.ShowBrandSearchResults == true;" class="GridBrandSearchResults">
                    <div class="GridBrandSearchResultsTopSearch">
                      <input type="text" placeholder="ex: SIEMENS" [(ngModel)]="this.parent.brandSearch" class="GridBrandSearchInput" matInput (ngModelChange)="this.parent.GetBrandsFilteredWithSuggestion(this.parent.brandSearch);"/>
                    </div>
                    <div class="GridBrandSearchResultsBody" *ngIf="this.parent.BrandsLoading != true;">
                      <div class="GridBrandSearchRow" *ngFor="let brand of this.parent.Brands; let b = index;" (click)="this.parent.SelectItemBrand(item, brand);">
                        <span>{{brand.Name}}</span>
                      </div>
                    </div>
                    <mat-spinner *ngIf="this.parent.BrandsLoading == true;" diameter="25" class="BrandsLoadingSpinner"></mat-spinner>
                  </div>
                </div>
            
                <div class="GridCol leftText DottedRow" style="width: Calc(25% - 2px); background: #fff;padding-left: 0!important; cursor: pointer;" [ngClass]="{'awaitingChoiceMarkedRows': item?.CartItemStatus?.ID == -1, 'notFoundMarkedRows': item?.CartItemStatus?.ID == -2 && item?.WasSearchedFor == true, 'validMarkedRows': item?.CartItemStatus?.ID == 1, 'invalidMarkedRows': item?.CartItemStatus?.ID == 0}">
                  <textarea disabled="true" *ngIf="item.LoadingCell != true;" class="GridColFullText" type="text" (click)="this.parent.InitializeSearchProduct(item);" [(ngModel)]="item.UIProductValue" matInput (ngModelChange)="this.parent.searchTermUpdate.next($event)"></textarea>
                  <input disabled="true" *ngIf="item.LoadingCell == true;" class="GridColFullText" type="text" matInput (ngModelChange)="this.parent.OnlyNumbers($event)"/>
                  <i class="material-icons cellCheckIcon" *ngIf="item?.CartItemStatus?.ID == 1;">check</i>
                  <mat-spinner *ngIf="item.LoadingCell == true;" diameter="25" class="CellSpinner"></mat-spinner>
                  <div *ngIf="item.ShowSearchResults == true && item?.SearchResults?.length > 0;" class="itemChoiceContainer">
                    <div *ngFor="let s of this.item.SearchResults; let j = index;" class="cellSearchResultRow" (click)="this.parent.SelectGridSearchResult(s, item);" [ngClass]="{'SelectedOfferRow': s.IsSelected == true}">
                      <span>{{s.FKBrandName}}</span>  
                      <span>{{s.ProductName}}</span> <span *ngIf="s.ProductPartNumber?.length > 0;">(PN: {{s.ProductPartNumber}})</span>
                      <i class="material-icons SelectedGridSearchResult" *ngIf="s.IsSelected == true;">check</i>
                    </div>
                  </div>
                </div>

                <div class="GridCol" style="width: Calc(30% - 2px); background: #fa6; color: #000; cursor: pointer;" (click)="SelectItemSupplierVariants(item);">
                  <span class="DottedRow" *ngIf="item.SelectedOffer != null;">{{item.SelectedOffer?.Partner?.Name}} ({{item.SelectedOffer?.DiscountedPrice}} {{item.SelectedOffer?.Currency?.Name}})</span>
                  <div class="SuppliersVariantContainer" *ngIf="item.IsSelected == true;">

                  </div>
                </div>
            
                <div class="GridCol" style="width: Calc(5% - 2px); background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  <div class="MOQSign" *ngIf="item?.SelectedOffer?.ChangedQunatityFromMOQ == true" matTooltip="{{'MOQDesc' | translate}} {{item.SelectedOffer.MOQ}}" matTooltipClass='neutral-tool-tip'></div>
                  <input disabled="true" class="GridColFullText" type="text" [(ngModel)]="item.Quantity" matInput *ngIf="item.Quantity > 0" (ngModelChange)="this.parent.OnlyNumbers($event)" (change)="this.parent.ChangeGridCellItem(item);"/>
                </div>
            
                <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}" matTooltip="Initial: {{item?.OriginalPrice?.UIUnitPrice}} {{this.CurrentOrder?.Cart?.Currency?.Symbol}}" matTooltipClass='neutral-tool-tip'>
                  <input [ngClass]="{'DifferentPrice': item?.Price?.UIUnitPrice != item?.OriginalPrice?.UIUnitPrice}" class="GridColFullText" type="text" [(ngModel)]="item.Price.UIUnitPrice" matInput (keydown)="this.parent.OnlyNumbers($event)" (change)="this.ChangeGridCellItem(item);"/>
                </div>
            
                <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{item.Price?.UIQtyPrice}} {{this.CurrentOrder.Cart.Currency?.Symbol}}
                </div>
            
              <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == -1" style="background: #f60;" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 0" style="background: #32aa3a;" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 1" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span *ngIf="item.SelectedOffer?.LeadTime != null;">{{item.SelectedOffer?.LeadTime?.Units}} {{item.SelectedOffer?.LeadTime?.Type?.Name}}</span>
                <span *ngIf="item.SelectedOffer?.LeadTime == null;">------</span>
              </div>
              </div>
            </div>
          </div>
        </div>

    </div>

    <div class="EditContainerControlls">
      <button mat-raised-button color="primary" class="EditContainerControllsButton" (click)="AddNewOfferRequest();">
       <div *ngIf="this.parent.loading != true;">
          <i class="material-icons">save_alt</i>
          <span>{{'Save' | translate}}</span>
       </div>
       <mat-spinner  *ngIf="this.parent.loading == true;" diameter="25" class="SaveButtonSpinner"></mat-spinner>
      </button>

      <!-- <button mat-raised-button class="EditContainerControllsButton" style="float: right; margin-right: 2.5%;color: #fff;">
        <i class="material-icons">content_copy</i>
        <span>{{'Copy' | translate}}</span>
      </button> -->
    </div>
</div>

<div class="MainOrdersContainer">
  
  <div class="OrderControlls">
    <div class="MainTitleBar" style="overflow: hidden;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.MasterData.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetOrdersFiltered();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer" style="margin-top: -4px;">
            <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetOrdersFiltered();">
              <mat-icon>filter_alt</mat-icon>
            </button>
        </div>
      
    </div>

    <div class="MainTitleBar" style="overflow: unset;">
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
            <i class="material-icons">filter_alt</i>
            <span>Filter</span>
        </div>

        <div class="FilterButton noselect" style="margin-left: 10px;" *ngIf="AnyChecked" (click)="ShowExportBulkQuestion = true;">
          <i class="material-icons">file_copy</i>
        </div>
    
        <div class="ActiveFiltersContainer">
          <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
            {{a.Name}}
            <i class="material-icons">close</i>
          </div>
        </div>
    
        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>
    
            <div class="FilterContainerBody">
    
                <div class="PopUpBodyRow">
                </div>
               
                <div class="PopUpBodyTwoThirdsContainer">
                    <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                        <mat-label>{{ 'DebatorPO' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'DebatorPO' | translate }}" autocomplete="off" [(ngModel)]="Filter.DebatorPO" (change)="AddActiveFilter('#: ' + Filter.DebatorPO, 'DebatorPO');">
                    </mat-form-field>
                </div>
                 
                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{ 'Status' | translate }}</mat-label>
                        <mat-select name="Series" [(ngModel)]="Filter.IndividualStatus">
                          <mat-option *ngFor="let d of this.MasterData.OfferRequestStatuses;" [value]="d" (click)="AddActiveFilter(d.Name, 'Status');">
                            {{d.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                
                <div class="PopUpBodyTwoThirdsContainer">
                     <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                        <mat-label>{{ 'SearchProductInvoicesFilter' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'SearchProductInvoicesFilter' | translate }}" autocomplete="off" [(ngModel)]="Filter.SearchTerm" (change)="AddActiveFilter('PN: ' + Filter.SearchTerm, 'Product');">
                      </mat-form-field>
                </div>

                <div class="PopUpBodyOneThirddContainer">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                      <mat-label>{{'Currency' | translate}}</mat-label>
                      <mat-select name="Currency" [(ngModel)]="Filter.Currency">
                        <mat-option *ngFor="let c of this.MasterData.Currencies;" [value]="c" (click)="AddActiveFilter(c.Name, 'Currency');">
                          {{c.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>

                <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field appearance="outline" style="width: 100%;padding: 0;" (click)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);">
                      <mat-label>{{ 'SearchClient' | translate }}*</mat-label>
                      <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.searchTerm = Partners[0].Name; this.Filter.Partner = Partners[0]; AddActiveFilter(Partners[0].Name, 'Partner');GetOfferRequestsFiltered();">
                      <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                      <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.Filter.Partner = null;">close</i>
                    </mat-form-field>
  
                    <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                      <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="resultsLength = 0; this.searchTerm=p.Name; this.Filter.Partner = p;AddActiveFilter(p.Name, 'Partner');">
                          <p class="SearchResultTitle DottedRow">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length;">{{p.VAT}}</span></p>
                      </div>
                    </div>
                </div>
                <div class="PopUpBodyOneThirddContainer"></div>

                <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                    <mat-label>{{'UserManager' | translate}}</mat-label>
                    <mat-select name="UserManager" [(ngModel)]="Filter.UserManager">
                      <mat-option *ngFor="let c of this.MasterData.UserManagers;" [value]="c" (click)="AddActiveFilter(c.Email, 'UserManager');">
                        {{c.Email}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="PopUpBodyOneThirddContainer"></div>

                <div class="PopUpBodyTwoThirdsContainer">
                 
                </div>
                <div class="PopUpBodyOneThirddContainer"></div>

                <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field appearance="outline" style="width: 100%;padding: 0;" (click)="InitializeUserClientsOnClick(this.UserClientsSearchTerm);">
                    <mat-label>{{ 'SearchUser' | translate }}*</mat-label>
                    <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.UserClientsSearchTerm" (ngModelChange)="this.searchB2BUser.next($event)" (keydown.enter)="this.UserClientsSearchTerm = UserClients[0].Email; this.Filter.UserUploader = UserClients[0]; AddActiveFilter(UserClients[0].Email, 'User');GetOfferRequestsFiltered();">
                    <mat-icon matSuffix (click)="GetUserClientsFiltered(this.UserClientsSearchTerm);" style="cursor: pointer;" *ngIf="this.Filter.UserUploader == null;">search</mat-icon>
                    <i class="material-icons searchCloseButton" *ngIf="this.UserClientsSearchTerm?.length > 0;" (click)="this.UserClientsSearchTerm=''; this.UserClients.length = 0;UserClientsLength = 0; this.Filter.UserUploader = null;">close</i>
                  </mat-form-field>

                  <div class="PartnerSearchResultsContainer" *ngIf="UserClientsLength > 0;">
                    <div class="PartnerSearchResult" *ngFor="let u of UserClients" (click)="UserClientsLength = 0; this.UserClientsSearchTerm = u.Email; this.Filter.UserUploader = u; AddActiveFilter(u.Email, 'UserUploader');">
                        <p class="SearchResultTitle DottedRow">{{u.Email}}</p>
                    </div>
                  </div>
                </div>  
                <div class="PopUpBodyOneThirddContainer"></div>
            </div>
            
            <div class="FilterCommands">
                <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetOrdersFiltered();">{{ 'Filter' | translate }}</button>
            </div>
        </div>

        <div class="TotalDocCountContainer">
          <span style="float: right;">{{this.Orders?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Orders' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
          <div class="PageSizeContainer">
            <mat-form-field appearance="outline" class="PageSizeTextBox">
              <mat-label>{{ 'PageSize' | translate }}*</mat-label>
              <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetOrdersFiltered(1);">
            </mat-form-field>
          </div>
        </div>

        <div class="TotalDocCountContainer">
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetOrdersFiltered(this.Filter.Pager.PageIndex - 1);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetOrdersFiltered(this.Filter.Pager.PageIndex + 1);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>
        </div>
    </div>

    <div class="MainTitleBar">
      <div class="MainOrdersSearchContainer">
        <input type="text" class="MainOrdersSearch" placeholder="{{'Search' | translate}}" [(ngModel)]="this.Filter.SearchTerm" (ngModelChange)="this.searchMainOrders.next($event)">
        <i class="material-icons" *ngIf="!this.LoadingMainSearchTerm && !(this.Filter?.SearchTerm?.length > 0);" (click)="GetOrdersFiltered();">search</i>
        <i class="material-icons" *ngIf="!this.LoadingMainSearchTerm && this.Filter?.SearchTerm?.length > 0;" (click)="ResetMainSearch();">close</i>
        <mat-spinner class="smallSpinner MainSearchLoadingSpinner" [diameter]="20" *ngIf="this.LoadingMainSearchTerm == true;"></mat-spinner>
      </div>
    </div>
  </div>

  <div class="OrdersTable">
    <div class="OrdersHeadder unSelectable">
      <div class="OrdersTableCol" style="width: 15%;">
        <p>{{'Client' | translate}}</p>
      </div>
        <div class="OrdersTableCol" style="width: 10%;">
            <p><i class="material-icons">numbers</i></p>
        </div>

        <div class="OrdersTableCol" style="width: 10%;">
            <p>{{'DebatorPO' | translate}}</p>
            <i class="material-icons">qr_code_2</i>
        </div>

        <div class="OrdersTableCol">
            <p>{{'AgentManager' | translate}}</p>
            <i class="material-icons">account_circle</i>
        </div>

        <div class="OrdersRowCol CenterLock" style="padding-top: 15px;">
            <p class="OrdersRowColInfo">{{'Status' | translate}}</p>
        </div>

        <div class="OrdersTableCol" style="width: 10%;">
            <p>{{'EventRegister' | translate}}</p>
            <i class="material-icons">access_time</i>
        </div>

        <div class="OrdersTableCol">
            <p>{{'PaymentType' | translate}}</p>
            <i class="material-icons">payment</i>
        </div>

        <div class="OrdersTableCol" style="width: 5%;">
            <p>{{'Tansport' | translate}}</p>
            <i class="material-icons">local_shipping</i>
        </div>

        <div class="OrdersRowCol CenterLock" style="padding-top: 15px;width: 5%;">
            <p class="OrdersRowColInfo">{{'Total' | translate}}</p>
        </div>

        <div class="OrdersTableCol" style="width: 5%;">
            <p>{{'Weight' | translate}}</p>
            <i class="material-icons">scale</i>
        </div>

        <div class="OrdersTableCol" style="width: 10%;">
            <p>{{'Actions' | translate}}</p>
            <i class="material-icons">play_arrow</i>
        </div>
    </div>

    <div class="OrdersBody" *ngIf="this.loadingOrders == true;">
        <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <div class="OrdersBody" *ngIf="this.loadingOrders != true;">
        <div class="OrdersRow" *ngFor="let o of this.Orders;" (dblclick)="AwknowledgeOrder(o); GetOfferRequest(o.ID);">
            <div class="OrdersRowCol" style="width: 15%;">
            <p class="OrdersRowColInfo">
              <span class="ReferenceNumber" (click)="AwknowledgeOrder(o); GetOfferRequest(o.ID);">{{o.Cart?.Partner?.Name}}</span>
            </p>
           </div>
            <div class="OrdersRowCol" style="width: 10%;">
                <p><span class="OrderNumberSpan">{{o.ReferenceNumber}}</span></p>
                <p><span style="background: #fd4f57;" class="OrderNumberSpan" *ngIf="o.InjectionError?.HasError == true;">{{'APIInjectionError' | translate}}</span></p>
                <p><span style="background: #fd4f57;" class="OrderNumberSpan" *ngIf="o.InjectionError?.Message?.length > 0;">{{o.InjectionError.Message}}</span></p>
                <div class="UnawknoledgedOrderStatus" *ngIf="o.ProcessingStatus?.ID == 0;" matTooltip="{{'NeedsWork' | translate}}" matTooltipClass='neutral-tool-tip'></div>
                <div style="background: #32aa3a;" class="UnawknoledgedOrderStatus" *ngIf="o.OfferRequestStatus.ID == 12;"></div>
            </div>
    
            <div class="OrdersRowCol" style="width: 10%;">
                <p class="OrdersRowColInfo">
                    <span class="DebatorPOSpan" *ngIf="o?.DebatorPO?.length > 0;">{{o.DebatorPO}}</span>
                </p>
            </div>
    
            <div class="OrdersRowCol">
                <p class="OrdersRowColInfo">{{o.UserManager.Email}}</p>
            </div>
    
            <div class="OrdersRowCol CenterLock">
                <p class="OrdersRowColInfo" matTooltip="{{o.OfferRequestStatus.Description}} ---> {{o.OfferRequestStatus.NextStep}}" matTooltipClass='neutral-tool-tip'>
                    <span class="OrdersRowColInfoStatusSpan" [ngClass]="{'NewOrderStatus': o.OfferRequestStatus.ID == -1, 'ProcessingOrderStatus': o.OfferRequestStatus.ID == 1,'PartiallyConfirmedOrderStatus': o.OfferRequestStatus.ID == 9,'ConfirmedOrderStatus': o.OfferRequestStatus.ID == 10 || o.OfferRequestStatus.ID == 12, 'CanceledOrderStatus': o.OfferRequestStatus.ID == 11}">{{o.OfferRequestStatus.Name}}</span>
                </p>
            </div>
    
            <div class="OrdersRowCol" style="width: 10%;">
                <p class="OrdersRowColInfo">{{o.EventRegisterUI}}</p>
            </div>
    
            <div class="OrdersRowCol">
                <p class="OrdersRowColInfo">{{o.Cart.PaymentType.Name}}</p>
                <p class="OrdersRowColDesc">({{o.Cart.PaymentTerm.Name}})</p>
            </div>
    
            <div class="OrdersRowCol" style="width: 5%;">
                <p class="OrdersRowColInfo">{{o.Cart.ShippingServiceType.Name}}</p>
                <p class="OrdersRowColDesc">({{o.Cart.ShippingResponsability.Name}})</p>
            </div>
    
            <div class="OrdersRowCol CenterLock" style="width: 5%;">
                <p class="OrdersRowColInfo">{{o.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer}}{{o.Cart?.Total?.UITotalQtyPriceNOVAT?.Decimals}} {{o.Cart?.Currency?.Name}}</p>
            </div>
    
            <div class="OrdersRowCol" style="width: 5%;">
                <p class="OrdersRowColInfo">{{o.Cart?.Weight}} {{o.Cart?.WeightMeasurementType?.Name}}</p>
            </div>

            <div class="OrdersRowCol" style="width: 10%;">
                <p class="OrdersRowColInfo">
                    <i (click)="AwknowledgeOrder(o); GetOfferRequest(o.ID);" class="material-icons buttonIcon" matTooltip="{{'TakeOver' | translate}}" matTooltipClass='neutral-tool-tip'>edit</i>
                    <i (click)="ExportOrder(o);" class="material-icons buttonIcon" matTooltip="{{'DownloadPDF' | translate}}" matTooltipClass='neutral-tool-tip' style="color: #32aa3a;">file_download</i>
                    <i (click)="PrintOrder(o);" class="material-icons buttonIcon" matTooltip="{{'PrintDocument' | translate}}" matTooltipClass='neutral-tool-tip'>print</i>
                </p>
                
                <div class="ConfirmButton" *ngIf="o.OfferRequestStatus?.ID >= 10;" (click)="PreCheckOfferRequestConfirmation(o);">
                  <i class="material-icons">check</i>
                  <span>{{'Confirm' | translate}}</span>
                </div>

                <div class="ConfirmButtonWarn" *ngIf="o.OfferRequestStatus?.ID < 10;" (click)="PreCheckOfferRequestConfirmation(o);">
                  <i class="material-icons">warning_amber</i>
                  <span>{{'Confirm' | translate}}</span>
                </div>

                <div style="margin-top: 10px;" class="ConfirmButtonWarn" *ngIf="o.OfferRequestStatus?.ID != 11;" (click)="OpenOrderCancelation(o);">
                  <i class="material-icons">close</i>
                  <span>{{'Cancel' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>